import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/sokoban.json";
import fr from "@/locales/fr/puzzle-types/sokoban.json";

export const SOKOBAN_NS = "puzzle-types/sokoban";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerSokobanTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", SOKOBAN_NS))
    i18n.addResourceBundle("en", SOKOBAN_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", SOKOBAN_NS))
    i18n.addResourceBundle("fr", SOKOBAN_NS, fr, true, true);
}
